<template>
    <div id="mobile-renewClass">
        <div class="popup-head" @click="close_popup">
            <i class="el-icon-arrow-left"></i>返回
            <!--                <span>返回</span>-->
        </div>
        <div class="popup-content">
            <div class="content-head">续班</div>
            <div class="content-content-box">
                <div class="item-item-box">
                    <p class="item-left">
                        班级名称
                    </p>
                    <p class="item-right">
                        <span>{{class_name}}</span>
                    </p>
                </div>
                <div class="item-item-box  item-margin-box" @click="showClassInput">
                    <p class="item-left">
                        <i>*</i><span>选择学生</span>
                    </p>
                    <p class="item-right">
                        <van-cell  is-link :arrow-direction="show_class_input?'down':''" :value="'已选择'+(cur_stu_list.length*1)+'学生'"/>
                    </p>
                </div>
                <div class="item-item-box">
                    <p class="item-left">
                        单价
                    </p>
                    <p class="item-right">
                        ￥ <span class="price-day-item">{{day_price}}</span>/人/天
                    </p>
                </div>
                <div class="item-item-box">
                    <p class="item-left">
                        新增学生
                    </p>
                    <p class="item-right">
                        <van-stepper v-model="stu_num" min="0"  @blur="has_input" @plus="add_num" @minus="min_stu"/>
                    </p>
                </div>
                <div class="item-item-box">
                    <p class="item-left">
                        <i>*</i><span>有效日期</span>
                    </p>
                    <p class="item-right">
                        <van-cell  is-link :arrow-direction="show_date_calendar?'down':''" :value="cur_date_value"  @click="show_date_calendar=true"/>
                        <van-calendar
                                color="#027BFE"
                                v-model="show_date_calendar"
                                type="range"
                                @confirm="sure_date_select"
                                confirm-text="确定"
                                confirm-disabled-text="请选择结束时间"
                        />
                    </p>
                </div>
                <div class="item-item-box item-margin-box" v-if="canClickSpoken">
                    <p class="item-left">
                        选购
                    </p>
                    <p class="item-right">
                        <van-checkbox v-model="pick_buy"  @change="change_spoken"  icon-size="16px">口语测评功能</van-checkbox>
                    </p>
                </div>
                <div class="item-item-box ">
                    <p class="item-left">
                        付款方式
                    </p>
                    <p class="item-right">
                        <van-radio-group v-model="pay_methods" direction="horizontal" icon-size="16px" @change="change_pay_methods">
                            <van-radio :name="2">学生支付</van-radio>
                            <van-radio :name="1">老师支付</van-radio>
                        </van-radio-group>
                    </p>
                </div>
            </div>
            <div class="content-bottom">
                <div class="bottom-left" >
                    <p>共{{((stu_num*1)+(cur_stu_list.length*1))}}人，{{class_time_day}}天</p>
                    <p v-if="pay_methods==2">合计：￥<span>{{total_price}}</span>/人</p>
                    <p v-else>合计：￥<span>{{total_price}}</span></p>
                </div>
                <div class="bottom-right">
                    <van-button type="default" @click="save_class_info">{{pay_methods==2?'确定':'去支付'}}</van-button>
                </div>
            </div>
        </div>
        <addModel :allStuList="class_stu_list" :selectList="cur_stu_list" v-if="show_stu_list" @closeStuList="closeStuListFun"></addModel>
        <van-dialog v-model="dialogVisible" height="208px" title="账号详情" confirmButtonText="关闭"  @confirm="close_stu_list"  class="stu-list-class">
            <div class="stu-list-box">
                <div class="stu-id-list">
                    <p>学生账号</p>
                    <p v-if="stu_list_data.length>0&&stu_list_data.length>1">{{stu_list_data[0].username}}~{{stu_list_data[stu_list_data.length-1].username}}</p>
                    <p v-if="stu_list_data.length>0&&stu_list_data.length==1">{{stu_list_data[0].username}}</p>
                </div>
                <div class="stu-ps-list">
                    <p>密码</p>
                    <p>{{stu_ps}}</p>
                </div>
            </div>
        </van-dialog>
<!--        请确认微信订单是否完成-->
        <van-dialog v-model="test_dialogVisible" height="208px" title="" class="stu-list-class"  @confirm="check_pay" confirmButtonText="已完成支付"  cancelButtonText="关闭"  >
            <p style="text-align:center;font-size: 14px;line-height: 0.3rem;padding: 0 0.1rem;margin: 0.1rem 0;">确认订单，请在微信内完成支付</p>
       </van-dialog>
        <van-dialog v-model="paydialogVisible" height="208px" title="" class="stu-list-class" @cancel="cancel_pay"  @confirm="renew_pay" showCancelButton confirmButtonText="继续付款"  cancelButtonText="取消"  >
            <p style="font-size: 14px;line-height: 0.3rem;padding: 0 0.4rem;margin: 0.2rem 0;">您当前还没有完成付款，请点击【继续付款】进行支付</p>
        </van-dialog>
    </div>
</template>

<script>

    import Vue from "vue";
    import Vant from "vant";
    import { Notify } from 'vant';
    Vue.use(Notify);
    Vue.use(Vant);
    import * as api from "../../part/js/orderInfoApi";
    import axios from "axios";
    import addModel from './addModel'
    import weachetPay from './weachetPay.vue'

    export default {
        name: "renewClass",
        props: {
            singlePrice:{
                type:Object,
            },
            curClassId:{

            },
            canClickSpoken:{
                // type:Boolean,
            }
        },
        components:{
            addModel,//学生列表弹窗
            weachetPay
        },
        data(){
            return{
                paydialogVisible:false,
                test_dialogVisible:false,
                pick_buy:this.canClickSpoken, //是否选购口语

                sure_stu_list:[],//弹窗中选择的学生
                popup_show:true,
                cur_stu_list:[],//选择的学生
                show_stu_list:false,
                show_class_input:false,//班级名称输入框
                class_name_input:'',//班级名称
                class_name_input_s:'',
                stu_num:0,//学生数量
                show_date_calendar:false,//日期选择
                cur_date_value:'',//选择的开始结束时间
                cur_date_arr:[],//选择的开始结束时间
                can_click_spoken:false,//是否是英语学科
                can_show_spoken:false,
                single_price:{},//口语加个与单价
                pick_spoken:(this.can_click_spoken && this.can_show_spoken),//是否选择口语
                // pick_spoken:true,//是否选择口语
                pay_methods:1,//支付方式
                day_price:0,//单价
                spoken_price:0,//口语价格
                total_price:0.00,//总价
                class_time_day:0,//有效时长
                class_name:'',//班级名称
                class_stu_list:[],//全部的学生


                has_click_save:false,
                stu_list_data:[],//学生列表
                stu_ps:'',
                pay_img_data:'',
                total_amount:0,
                cur_order_id:'',//当前订单id
                has_pay_order:false,//是否支付
                dialogVisible:false,
                windo_ref:null,
            }
        },
        methods:{
            //点击取消
            cancel_pay(){
                this.test_dialogVisible = false;
                this.paydialogVisible = false;
                this.init_fun();
                this.$emit('onlyClose');
            },
            //点击已完成支付
            check_pay(){
                this.test_dialogVisible = false;
                this.paydialogVisible = false;
                if(this.has_pay_order){
                    this.has_click_save = true;
                    sessionStorage.setItem('hasClickSave',this.has_click_save);
                    if(this.stu_list_data.length>0){
                        this.dialogVisible = true;
                    }else{
                        this.$emit('paySuccecc');
                    }
                }else{
                    if(this.pay_methods==2){
                        if(this.stu_list_data.length>0){
                            this.dialogVisible = true;
                            return;
                        }
                        Notify({ type: 'success', message: '续班成功，请通知学生或家长至订单详情页去支付订单。' });
                        this.$emit('onlyClose');
                    }else{
                        this.paydialogVisible = true;
                    }
                }
            },
            renew_pay(){
                let u = navigator.userAgent;
                let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
                if(isIOS&&this.pay_methods==1){
                    this.windo_ref=window.open("",);
                }
                // this.renewClass();
                this.teaWeaPay(this.cur_order_id);
            },

            //口与选购
            change_spoken(val){
                if(val){
                    this.day_price = (this.singlePrice.price*1)+(this.singlePrice.spokenPrice*1);
                }else{
                    this.day_price = this.singlePrice.price;
                }
                this.filter_total_price();
            },
            //关闭学生列表选择弹窗
            closeStuListFun(val){
                this.show_stu_list = false;
                this.cur_stu_list = _.cloneDeep(val.selsect_data);
                this.filter_total_price();
            },
            //减少学生
            min_stu(){
                if (this.stu_num && this.stu_num > 999) {
                    this.stu_num = (this.stu_num.slice(0,3)*1);
                }
                if (this.stu_num && this.stu_num < 0) {
                    this.stu_num = 0;
                }
                this.stu_num--;
                this.filter_total_price();
            },
            //增加
            add_num(){
                if (this.stu_num && this.stu_num > 999) {
                    this.stu_num = (this.stu_num.slice(0,3)*1);
                }
                if (this.stu_num && this.stu_num < 0) {
                    this.stu_num = 0;
                }
                this.stu_num++;
                this.filter_total_price();
            },
            //输入框
            has_input(val){
                if (this.stu_num && this.stu_num > 999) {
                    this.stu_num = (this.stu_num.slice(0,3)*1);
                }
                if (this.stu_num && this.stu_num < 0) {
                    this.stu_num = 0;
                }
                this.filter_total_price();
            },
            //修改支付方式
            change_pay_methods(val){
                this.filter_total_price();
            },
            //关闭弹窗
            close_popup(){
                this.init_fun();
                this.$emit('closeModel')
            },
            init_fun(){
                this.windo_ref =null;
                this.has_click_save = false;
                this.total_price=0;
                this.pay_methods = 1;
                this.pick_buy = this.canClickSpoken;
                this.class_time_day= 0;
                this.stu_num = 0;
                this.class_time = '';
                this.cur_date_arr =[];
                this.cur_date_value = '';
                sessionStorage.setItem('hasClickSave',false);
                this.$forceUpdate();
            },
            close_input(){
                this.class_name_input = '';
            },
            //
            showClassInput(){
                // console.log(this.show_stu_list)
                this.show_stu_list = true;
                this.sure_stu_list = _.cloneDeep(this.cur_stu_list)
                this.class_stu_list.forEach((item, index) => {
                    item.check = false;
                    this.sure_stu_list.forEach((del_stu)=>{
                        if(del_stu==item.id){
                            item.check = true;
                        }
                    });
                });
            },
            //确认保存班级名称
            save_input_name(){
                this.class_name_input_s = this.class_name_input;
                this.show_class_input = false;
            },
            //取消修改班级名称
            cancel_input_name(){
                this.show_class_input = false;
            },

            //开班日期选择
            sure_date_select(val){
                if(!val){
                    this.class_time_day=0;
                    return ;
                }
                this.cur_date_arr = val;
                this.class_time_day = (val[1] - val[0] )/ (1000 * 60 * 60 * 24)+1;
                this.show_date_calendar = false;
                this.cur_date_value = this.format(val[0].getTime()/1000, "yyyy.MM.dd")+'~'+this.format( val[1].getTime()/1000, "yyyy.MM.dd");
                this.filter_total_price();
            },

            //计算总价
            filter_total_price(){
                if(this.pay_methods==1){
                    this.total_price = ((this.stu_num*1+this.cur_stu_list.length)*this.day_price*this.class_time_day).toFixed(2) ;
                }else{
                    this.total_price = (this.day_price*this.class_time_day).toFixed(2) ;
                }
            },
            //添加班级接口
            renewClass(){
                api.renewClass({
                    num:this.stu_num,
                    start:this.format(this.cur_date_arr[0].getTime()/1000, "yyyy-MM-dd"),
                    end:this.format(this.cur_date_arr[1].getTime()/1000, "yyyy-MM-dd"),
                    oral:this.pick_buy?1:0,//是否包含口语
                    user_pay:this.pay_methods,//支付方式
                    class_id:this.curClassId,
                    student_ids:this.cur_stu_list,
                }).then((res)=>{
                    if(res.errCode==0){
                        if(res.errCode==0){
                            // this.$message.success(res.msg);
                            this.cur_order_id = res.data.id;
                            if(this.pay_methods!=2){
                                this.teaWeaPay(res.data.id);
                            }else {
                                // this.$message.success(res.msg);
                                if(this.stu_num==0){
                                    this.$emit('onlyClose');
                                    this.$loading.hide();
                                    this.imgModelShow = false;
                                   Notify({ type: 'success', message: '续班成功，请通知学生或家长至订单详情页去支付订单。',className:'jp-notify-akadm' });
                                    return;
                                }
                                this.has_click_save = true;
                                sessionStorage.setItem('hasClickSave',this.has_click_save);
                                this.dialogVisible = true;
                                this.imgModelShow = false;
                                this.stu_ps = res.data.default_password;
                                this.stu_list_data = _.cloneDeep(res.data.new_students);
                                this.$loading.hide();
                            }
                        }else{
                            Notify.error(res.msg)
                        }
                    }
                }).catch(err=>{
                    console.log(err)
                })
            },
            //获取教培班级学生列表
            getJpstudents(){
                api.getJpstudents({
                    class_id:this.curClassId,
                    // class_id:1654
                }).then((res)=>{
                    if(res.errCode==0){
                        this.cur_stu_list =[];
                        this.sure_stu_list = [];
                        this.class_name = res.data.name;
                        this.class_stu_list = _.cloneDeep(res.data.students);
                        this.class_stu_list.forEach((item, index) => {
                            item.check = false;
                            res.data.default_students.forEach((del_stu)=>{
                                if(del_stu.id==item.id){
                                    item.check = true;
                                    this.cur_stu_list.push(item.id);
                                    this.sure_stu_list.push(item.id);
                                }
                            });
                        });
                    }
                }).catch(err=>{
                    console.log(err)
                })
            },
            //微信支付
            teaWeaPay(id){
                api.teaWeaPay({
                    order_id:id,
                    // method:'scan',
                    method:'wap',
                }).then((res)=>{
                    if(res.errCode==0){
                        sessionStorage.setItem('orderId',id);
                        let u = navigator.userAgent;
                        let encode_url =  encodeURIComponent(window.location.hostname+'/m/personal-center/copy');
                        let new_url = res.data.mweb_url+'&redirect_url='+encode_url ;
                        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
                        if(isIOS){
                            if(this.pay_methods==1){
                                // var winRef = window.open("","_blank");
                                this.windo_ref.location.href = new_url;
                                // this.windo_ref.location = new_url;
                                this.$loading.hide();
                                this.test_dialogVisible = true ;
                                setTimeout(()=>{
                                    this.windo_ref.close();
                                    // this.windo_ref =null ;
                                },3000)
                            }
                            this.getOrderInfo(id);
                            // window.open(res.data.mweb_url,'_blank')
                            // var a_dom = document.createElement('a');
                            // a_dom.href =new_url;
                            // a_dom.setAttribute("target", "_blank");
                            // a_dom.click();
                            // setTimeout(()=>{
                            //     window.location = "/m/personal-center/copy"
                            // },2000)
                        }else{
                            window.open(res.data.mweb_url,'_blank');
                            this.test_dialogVisible = true ;
                            this.$loading.hide()
                            this.getOrderInfo(id);
                            // this.$router.push({
                            //     name: "m-personal-center-copy" ,
                            //     path:'m-personal-center-copy',
                            // });
                            // setTimeout(()=>{
                            //     window.location = "/m/personal-center/copy"
                            // },300)
                            // window.location.href=res.data.mweb_url//获取后跳转
                        }
                        return;
                    }
                }).catch(err=>{
                    console.log(err);
                })
            },
            getOrderInfo(id){
                if(this.has_pay_order ||(!this.test_dialogVisible&&!this.paydialogVisible)){
                    return;
                }
                let cancelToken = axios.CancelToken; //Axios使我修改axios原型链了。
                this.cancel_stu_number = cancelToken.source(); //取消上传token
                // 创建实例时设置配置的默认值
                var instance = axios.create();

                instance.get('/api/jp-class/get-order', {
                    params:{order_id:this.cur_order_id},
                    cancelToken: this.cancel_stu_number.token,
                    timeout:3000
                }).then(res=>{
                    if(res.data.errCode==0){
                        this.stu_ps = res.data.data.default_password;
                        this.stu_list_data = _.cloneDeep(res.data.data.new_students);
                        this.has_pay_order = res.data.data.is_paid;
                        if(!res.data.data.is_paid){
                            setTimeout(()=>{
                                this.getOrderInfo();
                            },2000)
                        }else{
                            this.getWsToken_fun(this.update_interation);
                        }
                    }

                }).catch(err=>{
                    console.log(err)
                })
            },
            //更新互动
            update_interation(){
                const host = this.$cookies.get("http_ws_host");
                $.ajax({
                    type: "GET",
                    url: host + "/api/akdm-service/update-class-students",
                    data: {
                        token: this.$cookies.get("ws_token"),
                        class_id:(this.$cookies.get('jp_teacher_class_id')||this.$cookies.get('class_id')),
                        request_cross_domain: window.location.host,
                    },
                    dataType: "json",
                    success: function(res) {

                    },
                    error: function(xhr, type) {

                    }
                });
            },
            //关闭支付二维码弹窗
            close_weachet(){
                if(this.stu_num>0){
                    if(this.pay_methods==2 || this.has_pay_order){
                        this.dialogVisible = true;
                    }
                }else{
                    if(!this.has_pay_order){
                        this.imgModelShow = false;
                    }else{
                        this.imgModelShow = false;
                        this.$emit('paySuccecc');
                    }
                }
            },
            //关闭学生列表弹窗
            close_stu_list(){
                this.dialogVisible = false;
                if(this.pay_methods==2){
                    Notify({ type: 'success', message: '续班成功，请通知学生或家长至订单详情页去支付订单。' });
                    this.$emit('onlyClose');
                }else{
                    Notify({ type: 'success', message: '续班成功' });
                    this.$emit('paySuccecc');
                }
                this.init_fun();
            },
            //保存
            save_class_info() {
                if(!this.cur_date_value){
                   Notify({ type: 'danger', message: '请选择必填项',className:'jp-notify-akadm' });
                    return;
                }
                if (((this.stu_num*1) + this.cur_stu_list.length )>= 1000) {
                   Notify({ type: 'danger', message: '一个班级学生数量不能超过999，请重新设置',className:'jp-notify-akadm' });
                    return;
                }
                if(((this.stu_num*1) + this.cur_stu_list.length )== 0){
                    Notify({ type: 'danger', message: '请选择要续班的学生',className:'jp-notify-akadm' });
                    return;
                }
                let u = navigator.userAgent;
                let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
                if(isIOS&&this.pay_methods==1){
                    this.windo_ref=window.open("",);
                }
                this.$loading.show();
                this.renewClass();
            },
            //取消开班
            closeModal() {
                this.total_price=0;
                this.pay_methods = 1;
                this.pick_buy = this.canClickSpoken;
                this.class_time_day= '';
                this.stu_num = 0;
                this.class_time = '';
                // this.cancel_stu_number.cancel();
                // this.$emit("onlyClose", false);
                this.$emit("closeModel", 'close');
            },
        },
        created() {
            // console.log(121212313123)
            // this.init_fun();
            // this.getJpstudents();
        },
        mounted() {

        },
        watch: {
            singlePrice:{
                handler(newVal,oldVal){
                    this.spoken_price = this.canClickSpoken? this.singlePrice.spokenPrice:0;
                    this.day_price = ((this.singlePrice.price*1)+(this.spoken_price*1)).toFixed(2);
                },
                deep:true,
                immediate:true,
            },
            curClassId:{
                handler(newVal,oldVal){
                    if(!this.curClassId){
                        return;
                    }
                    this.init_fun();
                    this.getJpstudents();
                },
                deep:true,
                immediate:true,
            },
        }

    }
</script>

<style scoped lang="scss">
    .item-item-box{
        padding: 0 0.1rem;
        overflow: hidden;
        border-bottom: 1px solid #0000001a;
        height: 0.44rem;
        line-height: 0.44rem ;
    }
    .item-left{
        //padding-left: 0.1rem;
        /*float: left;*/
        display: inline-block;
        color:#7b6e6e;
        i{
            color:red;
            font-style: normal;
            vertical-align: middle;
        }
        span{
            vertical-align: middle;
        }
    }
    .item-right{
        display: inline-block;
        width: calc(100% - 0.7rem);
        text-align: right;
        vertical-align: middle;

        /*float: right;*/
        /*width: calc(100% - 0.8rem);*/
        /*text-align: right;*/
        .price-day-item{
            color:#F5222D;
            font-size: 0.18rem;
        }
    }
    /deep/.van-cell{
        padding:5px 10px;
        /deep/.select-date-item {
            text-align: center;
            line-height: 0.3rem;
        }
    }
    .popup-head{
        background: #fff;
        line-height: 0.4rem;
        height: 0.4rem;
        @include fz_color;
        padding:0 0.1rem;
    }
    .content-head{
        height: 0.42rem;
        line-height: 0.42rem;
        padding-left: 0.16rem;
    }
    .content-content-box{
        .item-item-box{
            background: #fff;
        }
    }
    .item-margin-box{
        margin-bottom: 0.16rem;
    }
    /deep/.van-stepper__minus,/deep/.van-stepper__plus{
        background: rgba(0,0,0,0.1);
        width: 0.28rem;
        height: 0.28rem;
    }
    /deep/.van-stepper__input{
        width: 0.42rem;
        height: 0.28rem;
        line-height: 0.28rem;
        background: rgba(0,0,0,0.05);
    }
    /deep/.van-checkbox,/deep/.van-radio-group--horizontal{
        display: inline-flex;
    }
    .content-bottom{
        padding:0.1rem 0;
        width: 100%;
        position: absolute;
        bottom:0;
        background: #fff;
        >div{
            display: inline-block;
            vertical-align: middle;
        }
        .bottom-left{
            padding-left:0.1rem;
            width: 60%;
            p{
                line-height: 0.34rem;
                &:first-of-type{
                    color:rgba(0,0,0,0.6);
                }
                &:last-of-type{
                    span{
                        color:#F5222D;
                        font-size:0.18rem;
                        font-size:18px;
                    }
                }
            }
        }
        .bottom-right{
            width: 40%;
            text-align: center;
            .van-button{
                width: 1rem;
                height: 0.36rem;
                line-height: 0.36rem;
                text-align: center;
                border-radius:18px;
                background: #FA6400;
                color:#fff;
            }
        }
    }
    .van-input-p{
        position: relative;
        margin: 0.32rem 0.24rem;
        border-bottom: 1px solid rgba(0,0,0,0.1);
        .van-icon-clear{
            font-size: 0.2rem;
            color:rgba(0,0,0,0.3);
            position: absolute;
            right:0.26rem;
            top:25%;
        }
    }
    /deep/.van-dialog__footer--buttons{
        //height:55px;
    }
    /deep/.van-cell{
        font-size: 0.14rem;
        text-align: right;
        width: 100%;
        padding:5px 0px;
        &:not(:last-child)::after{
            border: 0 none!important;
        }
        /deep/.select-date-item {
            text-align: center;
            line-height: 0.3rem;
        }
        .van-cell__value--alone{
            text-align: right;
        }
    }
</style>